import { AppModal } from '@components/form/Modal';
import { Modal } from 'antd';
import { LogoutModalTypes } from '../profile-dropdown.types';
import { capitalize } from '@shared/utils/capitalize';
import { useTranslation } from 'react-i18next';

export function ModalLogout({ open, handleModalClose, handleLogout, loading }: LogoutModalTypes) {
  const { t } = useTranslation();
  return (
    <Modal
      title={
        <AppModal.Header>
          <AppModal.Title>{capitalize(t('confirm_logout'))}</AppModal.Title>
        </AppModal.Header>
      }
      centered
      open={open}
      footer={
        <AppModal.Footer>
          <AppModal.Button onClick={handleModalClose} className="flex-1 capitalize!">
            {t('cancel')}
          </AppModal.Button>
          <AppModal.Button color="danger" onClick={handleLogout} className="flex-1 capitalize!" loading={loading}>
            {t('logout')}
          </AppModal.Button>
        </AppModal.Footer>
      }
      classNames={{ content: 'max-w-[420px]' }}
      onCancel={handleModalClose}
    >
      <AppModal.Body>
        <div className="mb-4">{t('are_you_sure_you_want_to_logout_from_calilio')}</div>
      </AppModal.Body>
    </Modal>
  );
}
